import { Pressable } from "@/components/ui/pressable";
import { Center } from "@/components/ui/center";
import { Text } from "@/components/ui/text";
import { Image } from "@/components/ui/image";
import { VStack } from "@/components/ui/vstack";
import { HStack } from "@/components/ui/hstack";
import { ScrollView } from "react-native-gesture-handler";
import React, { useState } from 'react';
import { useDispatch } from 'react-redux'
import { TouchableOpacity } from 'react-native-gesture-handler';
import { useWindowDimensions } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';

import i18n from 'i18n-js';
import tutorial0 from '../assets/images/tutorial/tut_0.png';
import tutorial1 from '../assets/images/tutorial/tut_1.png';
import tutorial2 from '../assets/images/tutorial/tut_2.png';
import tutorial3 from '../assets/images/tutorial/tut_3.png';
import tutorial4 from '../assets/images/tutorial/tut_4.png';
import tutorial5 from '../assets/images/tutorial/tut_5.png';
import tutorial6 from '../assets/images/tutorial/tut_6.png';
import tutorial7 from '../assets/images/tutorial/tut_7.png';
import tutorial8 from '../assets/images/tutorial/tut_8.png';
import { switchScreen } from '../hooks/navigate';
import { updateSettings } from "../stores/mainSlice";

export default function Tutorial({ navigation }) {

    const [page, setPage] = useState(0)
    const dispatch = useDispatch()

    const endTutorial = () => {
        dispatch(updateSettings({ settings: { tutorialShown: true } }))
        switchScreen(navigation, 'Home')
    }

    const window = useWindowDimensions()

    function handleScroll(event) {
        let actPage = Math.round(event.nativeEvent.contentOffset.x / window.width)
        if (actPage != page) {
            setPage(actPage)
        }
    }

    const TutPage = ({ image, page }) => {
        return (
            <ScrollView className="flex-1 bg-secondary-50">
                <VStack space='sm' className={` w-screen px-6 py-1 `}>
                    <Image source={image} alt='Tutorial' resizeMode='contain' size="4xl" className={`max-h-[400px] self-center `} />
                    <Text bold className="text-black text-lg my-2 self-center">{i18n.t('tutorial.title' + page)}</Text>
                    <Text className="text-black text-lg self-center">{i18n.t('tutorial.text' + page)}</Text>
                </VStack>
            </ScrollView>
        );
    }

    return (
        <SafeAreaView edges={['top','bottom']} className="bg-primary-900">
            <VStack className="h-[100%] bg-secondary-50">
                <TouchableOpacity onPress={endTutorial}>
                    <Text bold className="text-primary-900 text-xl text-right mt-5 mr-5">{i18n.t(page == 8 ? 'tutorial.done' : 'tutorial.skip')}</Text>
                </TouchableOpacity>
                <ScrollView horizontal={true} decelerationRate={0} snapToInterval={window.width} snapToAlignment='center' onScroll={handleScroll} scrollEventThrottle={256} className={` height-${window.height} flex-1 bg-secondary-50 `}>
                    <TutPage image={tutorial0} page={0} />
                    <TutPage image={tutorial1} page={1} />
                    <TutPage image={tutorial2} page={2} />
                    <TutPage image={tutorial3} page={3} />
                    <TutPage image={tutorial4} page={4} />
                    <TutPage image={tutorial5} page={5} />
                    <TutPage image={tutorial6} page={6} />
                    <TutPage image={tutorial7} page={7} />
                    <TutPage image={tutorial8} page={8} />
                </ScrollView>
                <Center>
                    <HStack space='xs' className={` absolute bottom-5 `}>
                        {[0, 1, 2, 3, 4, 5, 6, 7, 8].map(u => <Pressable key={"U" + u} className={` ${page == u ? "bg-primary-900" : "bg-secondary-50"} p-1 h-3 w-3 rounded-full border-[2px] border-primary-900 `} />)}
                    </HStack>
                </Center>
            </VStack>
        </SafeAreaView>
    );
}
